import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { PaginaFAQ } from 'src/paginas/faq'
import {
  PaginaExecucoesBackgroundServices,
  PaginaItensBackgroundServices,
  PaginaResumoBackgroundServices
} from 'src/paginas/ipgs/background-services'
import { PaginaImpersonate } from 'src/paginas/ipgs/impersonate'
import {
  PaginaCadastroUsuarios,
  PaginaUsuarios
} from 'src/paginas/ipgs/usuarios'
import { ModoPaginaCadastro } from 'src/tipos'

const RotaBase = 'sistema'

export const RotasSistema = {
  Usuarios: `/${RotaBase}/usuarios`,
  Impersonate: `/${RotaBase}/impersonate`
}

export const RotasBackgroundServices = {
  Resumo: `/${RotaBase}/background-services`,
  Execucoes: `/${RotaBase}/background-services/execucoes`,
  Itens: `/${RotaBase}/background-services/itens`
}

export const RotasUsuario = {
  Cadastro: `${RotasSistema.Usuarios}/cadastro`,
  Edicao: `${RotasSistema.Usuarios}/edicao`
}

export const SistemaRotas: React.FC = () => {
  return (
    <Switch>
      <Route exact path={RotasSistema.Usuarios}>
        <PaginaUsuarios />
      </Route>
      <Route exact path={RotasSistema.Impersonate}>
        <PaginaImpersonate />
      </Route>
      <Route path={RotasUsuario.Cadastro}>
        <PaginaCadastroUsuarios modo={ModoPaginaCadastro.Inclusao} />
      </Route>
      <Route path={`${RotasUsuario.Edicao}/:id`}>
        <PaginaCadastroUsuarios modo={ModoPaginaCadastro.Edicao} />
      </Route>
      <Route path={`/${RotaBase}/FAQ/:unityId?/:topicId?/:qnaId?`}>
        <PaginaFAQ />
      </Route>
      <Route exact path={RotasBackgroundServices.Resumo}>
        <PaginaResumoBackgroundServices />
      </Route>
      <Route path={`${RotasBackgroundServices.Execucoes}/:service`}>
        <PaginaExecucoesBackgroundServices />
      </Route>
      <Route path={`${RotasBackgroundServices.Itens}/:executionId`}>
        <PaginaItensBackgroundServices />
      </Route>
    </Switch>
  )
}
